/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Rewind: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="rewind" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M680 0C304.4275 0 0 304.4275 0 680S304.4275 1360 680 1360C1055.5725 1360 1360 1055.5725 1360 680S1055.5725 0 680 0zM680 145.7324999999999C975.0774999999998 145.7324999999999 1214.2675 384.9224999999999 1214.2675 680S975.0774999999998 1214.2675 679.9999999999999 1214.2675C384.9225 1214.2675 145.7324999999999 975.0775 145.7324999999999 680S384.9225 145.7325000000001 679.9999999999999 145.7325000000001zM315.7325 680L607.1550000000001 922.845V437.1125L315.7325000000001 679.9575000000001zM947.155 922.845L655.7325000000001 680L947.155 437.1550000000001V922.8875z" : "M544 0C243.542 0 0 243.5420000000001 0 544S243.542 1088 544 1088C844.458 1088 1088 844.458 1088 544S844.458 0 544 0zM544 116.5859999999999C780.0619999999999 116.5859999999999 971.414 307.938 971.414 544S780.0619999999999 971.414 543.9999999999999 971.414C307.938 971.414 116.586 780.062 116.586 544S307.938 116.586 543.9999999999999 116.586zM252.586 544L485.724 738.2760000000001V349.6900000000001L252.5860000000001 543.9660000000001zM757.724 738.2760000000001L524.586 544L757.724 349.7240000000001V738.3100000000001z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Rewind.displayName = `Blueprint5.Icon.Rewind`;
export default Rewind;
